import React from "react";

import { Icon } from '@types';

const EmailIcon: Icon = ({ fill = '#000000' }) => (
  <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.7371 1.31787L10.639 10.5745L0.540771 1.31787" stroke={fill} strokeWidth="0.721299" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M0.540771 1.31787H20.7371V15.6236C20.7371 15.8468 20.6485 16.0609 20.4907 16.2187C20.3329 16.3765 20.1188 16.4652 19.8956 16.4652H1.38229C1.1591 16.4652 0.945061 16.3765 0.787246 16.2187C0.629431 16.0609 0.540771 15.8468 0.540771 15.6236V1.31787Z" stroke={fill} strokeWidth="0.721299" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.80296 8.89154L0.800293 16.2274" stroke={fill} strokeWidth="0.721299" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.4777 16.2274L12.4749 8.89148" stroke={fill} strokeWidth="0.721299" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default EmailIcon;
